<template>
    <div class="p-6 shadow-md rounded-md mb-15">
        <div class="flex justify-between items-start">
            <h3 class="font-bold text-3xl dark:text-gray-200 pr-6">{{ surveyType.type }}</h3>
        </div>
        <div class="pt-7">
            <div class="grid md:grid-cols-2 xl:grid-cols-4 gap-4">
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        {{ surveyTypeStats.totalUsers }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Total Users</p>
                </div>
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        {{ surveyTypeStats.totalRespondents }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Total Participants</p>
                </div>
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        {{ surveyTypeStats.averageResponseRate !== null ? surveyTypeStats.averageResponseRate + '%' : 'N/A' }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Average Response Rate</p>
                </div>
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        £{{ surveyTypeStats.totalRevenue }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Total Revenue</p>
                </div>
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        {{ surveyTypeStats.avgInvitesPerSurvey }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Average number of invites per survey</p>
                </div>
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        {{ surveyTypeStats.avgResponsesPerSurvey }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Average number of responses per survey</p>
                </div>
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        {{ surveyTypeStats.avgSurveysPerOrg }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Average number of surveys per user</p>
                </div>
                <!-- Card -->
                <div class="rounded-md bg-light flex items-center p-4">
                    <div class="flex items-center justify-center mr-4 rounded-full text-xl font-bold w-12 h-12 text-white bg-dark">
                        £{{ surveyTypeStats.avgRevenue }}
                    </div>
                    <p class="flex-1 text-xl font-bold leading-6">Average revenue per survey</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DashboardCard from "@/Components/DashboardCard";

export default {
    name: "SuperAdminSurveyStats",
    components: {
        DashboardCard,
    },
    props: {
        surveyType: {
            type: Object,
            required: true,
        },
        surveyTypeStats: {
            type: Object,
            default: {}
        }
    },

}
</script>

<style scoped>

</style>
